// product quantities (enable/disabled btn based on total quantity)

class ProductQuantities {

    constructor(el) {
        this.el = el;
        this.btn = this.el.querySelector('#product-quantities--submit-btn');
        if(this.btn != null) {
            this.formNumberControlInputs = this.el.querySelectorAll('.form-number-control input');
            if(this.formNumberControlInputs.length > 0) {
                // add listeners
                this.formNumberControlInputs.forEach(i => {
                    i.addEventListener('change', () => {
                        this.update();
                    });
                });
                // run update on pageload
                this.update();
            }
        }
    }

    update() {
        let total = 0;
        this.formNumberControlInputs.forEach(i => {
            total += parseInt(i.value);
        });
        if(total > 0) {
            this.btn.removeAttribute('disabled');
        } else {
            this.btn.setAttribute('disabled',true);
        }
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ProductQuantities(node);
        }
    });
}